import React, { useContext, useEffect, useState } from "react";
import { BrowserView, MobileView, isMobile } from "react-device-detect";
import Slider from "react-slick";
import styles from "../../../css/newsEvents.module.css";
import { scAxiosAdmin, thirdparty } from "../../..";
import {
  APIIMAGE_URL,
  API_TOKEN_NAME,
  IMAGE_URL,
  USER_ID,
  USER_LOCAL_ID,
} from "../../../constants";
import news_events_1 from "../../../images/new2.png";
import axios from "axios";
import { MyContext } from "../../MyProvider";
import $ from "jquery";
import SubPopupIndex2 from "../SubPopupIndex2";
import PatientRegisterPopup from "../PatientRegistrationPopup";
import PopupIndex2 from "../PopupIndex2";
import BookAppointmentPopup from "../BookAppointmentPopup";
import BookAppointmentParticularDoctorPopUp from "../BookAppointmentParticularDoctorPopUp";
import BookAppointmentTestimoniaDoctorPopUp from "../BookAppointmentTestimoniaDoctorPopUp";
import { Link } from "react-router-dom";
const Testimonials = () => {
  const [newsEventData, setNewsEventData] = useState([]);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [patientRegPopup, setPatientRegPopup] = useState(false);
  const [showPatientRegPopup, setShowPatientRegPopup] = useState("");
  const [showthirdpopup, setShowThirdPopup] = useState("");
  const [showDoctorSearchPopup, setShowDoctorSearchPopup] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const { DoctorData } = useContext(MyContext);
  const [step, setStep] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await thirdparty("/testimonials");
        // axios.get(`https://uhlbackend.etherstaging.xyz/api/testimonials/getalltestimonials`);

        // Accessing the first object in the array
        setNewsEventData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const settings = {
    rows: 1,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const mobileSettings = {
    rows: 1,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div>
      <section
        style={{ backgroundColor: "#F7F5EF" }}
        className={`news-events pb-0 ${isMobile ? "pt-0" : ""}`}
        id="hr-lines"
      >
        <div className="container ">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 auto",
            }}
          >
            <div className="">
              <h3
                className="text-left"
                style={{
                  color: "#af9763",
                  fontSize: "28px",
                  fontWeight: "500",
                }}
              >
                Testimonials
              </h3>
              {/* <img src="/assets/images/testimonial_under.png" alt="" /> */}
            </div>
            {/* <div
              className="d-flex justify-content-center align-items-center"
              role="button"
            >
              <img src="/assets/images/chat.png" alt="" />
              <p style={{ color: "#0C807D" }} className="ps-2 fw-bold">
                Share your Experience
              </p>
            </div> */}
          </div>

          <div className="row mt-4 pb-0 pb-md-5">
            <div className="col-md-12 right-sp-1">
              <div className="news_section">
                <div className="row" style={{ position: "relative" }}>
                  <div
                    className="d-flex justify-content-start align-items-center"
                    style={{
                      position: "absolute",
                      top: isMobile ? -25 : -50,
                      left: 0,

                      width: "fit-content",
                    }}
                  >
                    <img
                      className={`img-fluid ${isMobile ? "w-50" : "w-100"}`}
                      src="/assets/images/qutation_top.png"
                      alt=""
                      srcset=""
                    />
                  </div>
                  <div
                    className="d-flex justify-content-end align-items-center"
                    style={{
                      position: "absolute",
                      bottom: isMobile ? 5 : -25,
                      right: 0,

                      width: "fit-content",
                    }}
                  >
                    <img
                      className={`img-fluid ${isMobile ? "w-50" : "w-100"}`}
                      src="/assets/images/qutation_bottom.png"
                      alt=""
                      srcset=""
                    />
                  </div>
                  <MobileView className={`${styles.MobileView}`}>
                    <Slider {...mobileSettings}>
                      {newsEventData.length > 0 ? (
                        newsEventData.map((newsevent_data) => {
                          let departmentName = "not found";
                          if (
                            newsevent_data &&
                            newsevent_data.doctor_mave &&
                            newsevent_data.doctor_mave.department_mave
                          ) {
                            departmentName =
                              newsevent_data.doctor_mave.department_mave
                                .department_name || "not found";
                          }

                          return (
                            <div
                              className="col-sm-3 px-1 py-4"
                              key={newsevent_data.id}
                              style={{
                                width: "100%",
                                maxWidth: "432px",
                                height: "300px",
                              }}
                            >
                              <div
                                className="card p-2 d-flex flex-column justify-content-between align-items-start make-orange"
                                style={{
                                  paddingLeft: "0px",
                                  paddingRight: "0px",
                                  borderRadius: "14px",
                                  height: "250px",
                                  boxShadow:
                                    "0px 4px 6px rgba(0, 0, 0, 0.1), 0px -4px 6px rgba(0, 0, 0, 0.1)",
                                }}
                              >
                                <a
                                  href={"/testimonials/" + newsevent_data.id}
                                  style={{
                                    textDecoration: "none",
                                    color: "black",
                                    height: "50%",
                                  }}
                                >
                                  <div
                                    // style={{ height: "8rem" }}
                                    className="card-body d-flex flex-column justify-content-start align-items-start px-3 p-0  pt-1 "
                                  >
                                    <div className="d-flex justify-content-between align-items-start make-testimonial-text-white">
                                      <div
                                        className="pt-2"
                                        style={{
                                          textAlign: "left",
                                          fontSize: "14px",
                                          fontWeight: "500",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            newsevent_data.testimonial_desc
                                              ? newsevent_data.testimonial_desc
                                                  .split(" ")
                                                  .slice(0, 20)
                                                  .join(" ") + " ..."
                                              : "",
                                        }}
                                      ></div>
                                    </div>
                                  </div>{" "}
                                </a>
                                <div
                                  className="authorDetails d-flex justify-content-start align-items-center ms-3"
                                  style={{ width: "90%", height: "15%" }}
                                >
                                  <h3
                                    className="text-end w-100 make-testimonial-text-white"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "400",
                                      color: "#AF9763",
                                    }}
                                  >
                                    - {newsevent_data.author_name}
                                  </h3>
                                </div>
                                <hr
                                  // style={{ border: "none" }}
                                  className="text-decoration-none testimonial-button-hover-effect w-100"
                                />
                                <div
                                  className="d-flex justify-content-around align-items-start w-100 py-1 gap-2"
                                  style={{
                                    // borderTop: "1px solid #AF9763",
                                    height: "30%",
                                  }}
                                >
                                  <div>
                                    <img
                                      className="img-fluid rounded"
                                      src={
                                        newsevent_data.doctor_mave
                                          ? IMAGE_URL +
                                            "DoctorProfileImg/" +
                                            newsevent_data.doctor_mave
                                              .doctor_profile
                                          : news_events_1
                                      }
                                      width={50}
                                      height={50}
                                      alt="news_events_1"
                                    />
                                  </div>

                                  <div className="authorDetails d-flex flex-column align-items-start  m-0">
                                    <h5
                                      className="make-testimonial-text-white mb-0"
                                      style={{
                                        fontSize: "14px",
                                        color: "#AF9763",
                                      }}
                                    >
                                      {newsevent_data.doctor_mave
                                        ? newsevent_data.doctor_mave.doctor_name.slice(
                                            0,
                                            21
                                          )
                                        : ""}
                                    </h5>
                                    <h6
                                      className="make-testimonial-text-white"
                                      style={{
                                        fontSize: "10px",
                                        color: "#B5B5B6",
                                      }}
                                    >
                                      {newsevent_data.doctor_mave
                                        ? newsevent_data.doctor_mave.degree.slice(
                                            0,
                                            24
                                          )
                                        : ""}
                                    </h6>
                                    <h6
                                      className="make-testimonial-text-white"
                                      style={{
                                        fontSize: "10px",
                                        color: "#B5B5B6",
                                      }}
                                    >
                                      {departmentName}
                                    </h6>
                                  </div>
                                  <div className="btnDiv h-100 d-flex align-items-center">
                                    {localStorage.getItem(USER_LOCAL_ID) ? (
                                      <button
                                        type="button"
                                        className="btn-sm border-0 text-white testimonial-button-hover-effect"
                                        style={{
                                          // padding: "10px",
                                          // borderRadius: "5px",
                                          // backgroundColor: "#AF9763",
                                          width: "100px",
                                          fontSize: "16px",
                                        }}
                                        onClick={() =>
                                          setSelectedDoctor(
                                            newsevent_data.doctor_mave
                                          )
                                        }
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#BookAppointmentTestimoniaDoctorPopUp"
                                        aria-controls="BookAppointmentTestimoniaDoctorPopUp"
                                        // onClick={this.bookAppointmentPopup}
                                      >
                                        Book Now
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        className="btn-sm border-0 text-white testimonial-button-hover-effect"
                                        style={{
                                          // padding: "10px",
                                          // borderRadius: "5px",
                                          // backgroundColor: "#AF9763",
                                          width: "100px",
                                          fontSize: "16px",
                                        }}
                                        href="#offcanvasExample"
                                        data-bs-toggle="offcanvas"
                                        role="button"
                                        aria-controls="offcanvasExample"
                                      >
                                        Book Now
                                      </button>
                                    )}
                                    {/*  <button
                                        type="button"
                                        className="btn-success btn-sm"
                                        style={{
                                          // padding: "10px",
                                          // borderRadius: "5px",
                                          backgroundColor: "#0C807D",
                                          width: "100px",
                                          fontSize: "16px",
                                        }}
                                        // onClick={() =>
                                        //   handleBookNowClick(newsevent_data)
                                        // }
                                      >
                                        Book Now
                                      </button> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="col-sm-12 post-slide">
                          <div className="news-part">
                            <div className="bg-color-back">
                              <p>No any news & events founds</p>
                            </div>
                          </div>
                        </div>
                      )}
                    </Slider>
                  </MobileView>

                  <BrowserView className="px-0">
                    <Slider className="slider-1" {...settings}>
                      {newsEventData.length > 0 ? (
                        newsEventData.map((newsevent_data) => {
                          let departmentName = "Not found";
                          if (
                            newsevent_data &&
                            newsevent_data.doctor_mave &&
                            newsevent_data.doctor_mave.department_mave
                          ) {
                            departmentName =
                              newsevent_data.doctor_mave.department_mave
                                .department_name || "not found";
                          }

                          return (
                            <div
                              className="col-sm-3 px-2 py-5"
                              key={newsevent_data.id}
                              style={{
                                width: "100%",
                                maxWidth: "432px",
                                height: "400px",
                              }}
                            >
                              <div
                                className="card p-2 d-flex flex-column justify-content-between align-items-start make-orange shadow"
                                style={{
                                  paddingLeft: "0px",
                                  paddingRight: "0px",
                                  borderRadius: "14px",
                                  height: "290px",
                                }}
                              >
                                <Link
                                  to={"/testimonials/" + newsevent_data.id}
                                  style={{
                                    textDecoration: "none",
                                    color: "black",
                                    height: "40%",
                                  }}
                                  className=""
                                >
                                  <div
                                    // style={{ height: "8rem" }}
                                    className="card-body d-flex flex-column justify-content-start align-items-start px-3 p-0 pt-1"
                                  >
                                    <div className="d-flex justify-content-between align-items-start make-testimonial-text-white">
                                      <div
                                        className="pt-2"
                                        style={{
                                          textAlign: "left",
                                          fontSize: "16px",
                                          fontWeight: "500",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            newsevent_data.testimonial_desc
                                              ? newsevent_data.testimonial_desc
                                                  .split(" ")
                                                  .slice(0, 30)
                                                  .join(" ") + " ..."
                                              : "",
                                        }}
                                      ></div>
                                    </div>
                                  </div>{" "}
                                </Link>
                                <div
                                  className="authorDetails d-flex justify-content-start align-items-center ms-3"
                                  style={{ width: "90%", height: "15%" }}
                                >
                                  <h3
                                    className="text-end w-100 make-testimonial-text-white"
                                    style={{
                                      fontSize: "15px",
                                      fontWeight: "400",
                                      color: "#AF9763",
                                    }}
                                  >
                                    - {newsevent_data.author_name}
                                  </h3>
                                </div>
                                <hr
                                  // style={{ border: "none" }}
                                  className="text-decoration-none testimonial-button-hover-effect w-100"
                                />
                                <div
                                  className="d-flex justify-content-around align-items-start w-100 py-3"
                                  style={{
                                    // borderTop: "1px solid #AF9763",
                                    height: "30%",
                                  }}
                                >
                                  <div>
                                    <img
                                      className="img-fluid rounded"
                                      src={
                                        newsevent_data.doctor_mave
                                          ? IMAGE_URL +
                                            "DoctorProfileImg/" +
                                            newsevent_data.doctor_mave
                                              .doctor_profile
                                          : news_events_1
                                      }
                                      width={50}
                                      height={50}
                                      alt="news_events_1"
                                    />
                                  </div>

                                  <div className="authorDetails d-flex flex-column align-items-start  m-0">
                                    <h5
                                      className="make-testimonial-text-white"
                                      style={{
                                        fontSize: "16px",
                                        color: "#AF9763",
                                      }}
                                    >
                                      {newsevent_data.doctor_mave
                                        ? newsevent_data.doctor_mave.doctor_name.slice(
                                            0,
                                            21
                                          )
                                        : ""}
                                    </h5>
                                    <h6
                                      className="make-testimonial-text-white"
                                      style={{
                                        fontSize: "12px",
                                        color: "#B5B5B6",
                                      }}
                                    >
                                      {newsevent_data.doctor_mave
                                        ? newsevent_data.doctor_mave.degree.slice(
                                            0,
                                            24
                                          )
                                        : ""}
                                    </h6>
                                    <h6
                                      className="make-testimonial-text-white"
                                      style={{
                                        fontSize: "12px",
                                        color: "#B5B5B6",
                                      }}
                                    >
                                      {departmentName}
                                    </h6>
                                  </div>
                                  <div className="btnDiv h-100 d-flex align-items-center">
                                    {localStorage.getItem(USER_LOCAL_ID) ? (
                                      <button
                                        type="button"
                                        className="btn-sm border-0 testimonial-button-hover-effect"
                                        style={{
                                          // padding: "10px",
                                          // borderRadius: "5px",
                                          // backgroundColor: "#AF9763",
                                          width: "100px",
                                          fontSize: "16px",
                                        }}
                                        onClick={() =>
                                          setSelectedDoctor(
                                            newsevent_data.doctor_mave
                                          )
                                        }
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#BookAppointmentTestimoniaDoctorPopUp"
                                        aria-controls="BookAppointmentTestimoniaDoctorPopUp"
                                        // onClick={this.bookAppointmentPopup}
                                      >
                                        Book Now
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        className="btn-sm border-0 testimonial-button-hover-effect"
                                        style={{
                                          // padding: "10px",
                                          // borderRadius: "5px",
                                          // backgroundColor: "#AF9763",
                                          width: "100px",
                                          fontSize: "16px",
                                        }}
                                        href="#offcanvasExample"
                                        data-bs-toggle="offcanvas"
                                        role="button"
                                        aria-controls="offcanvasExample"
                                      >
                                        Book Now
                                      </button>
                                    )}
                                    {/*  <button
                                        type="button"
                                        className="btn-success btn-sm"
                                        style={{
                                          // padding: "10px",
                                          // borderRadius: "5px",
                                          backgroundColor: "#0C807D",
                                          width: "100px",
                                          fontSize: "16px",
                                        }}
                                        // onClick={() =>
                                        //   handleBookNowClick(newsevent_data)
                                        // }
                                      >
                                        Book Now
                                      </button> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                        <div className="col-sm-12 post-slide">
                          <div className="news-part">
                            <div className="bg-color-back">
                              <p>No any news & events founds</p>
                            </div>
                          </div>
                        </div>
                      )}
                    </Slider>
                  </BrowserView>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {selectedDoctor ? (
        <BookAppointmentTestimoniaDoctorPopUp
          doctorData={selectedDoctor}
          setSelectedDoctor={setSelectedDoctor}
        ></BookAppointmentTestimoniaDoctorPopUp>
      ) : null}
    </div>
  );
};

export default Testimonials;



// WEBPACK FOOTER //
// ./src/component/frontend/commonsections/Testimonials.js